'use strict';

const urlUtil = require('../1774/utils/url');
const util = require('../utils/util');
const fitguideselectedmillimeters = require('./fitguideselectedmillimeters');
const offcanvasdialog = require('../components/offcanvasdialog');
const minicart = require('../components/header/minicart');
const cartoverlay = require('../components/checkout/cartoverlay');

const fitGuideOnClickEvents = {
    /**
     * @function
     * @description initialize estimate events
     */

    init: function fitGuideOnClickEvents(sizes, isPDP, isCart) {
        const $fitGuideCalculator = $('.fit-guide-calculator');
        const $calculateButton = $fitGuideCalculator.find('.calculate-button');
        const $fitGuideForm = $fitGuideCalculator.find('.fit-guide-form');
        const $fitGuideResult = $fitGuideCalculator.find('.container-result');
        const $notFoundSuggestionMessage = $fitGuideCalculator.find('.warning-form-not-found-suggestion');
        const $exploreButton = $fitGuideCalculator.find('.explore-shop');
        const $backToCart = $fitGuideCalculator.find('.back-to-cart');
        const categoryUrl = urlUtil.appendParamToURL(Urls.search, 'cgid', 'models');
        const addToCart = require('../pages/product/addToCart');
        const $measurementFields = $fitGuideCalculator.find('.select-wrapper select');
        const pid = $('.product-variations .flyin-product-info-fit-guide').data('pid');
        let inputFieldError = false;
        let showProductEventSend = true;

        $('.fit-guide-calculator .restart')
            .off()
            .on('click keypress', function () {
                clearSelect();
                restartCalculator();
                setDefaultOption();
                if (window.dataLayer) {
                    if (isCart) {
                        window.dataLayer.push({
                            event: 'fitGuideRecalculate_Cart'
                        });
                    } else {
                        window.dataLayer.push({
                            event: 'fitGuideRecalculate'
                        });
                    }
                }
            });

        $calculateButton.off().on('click keypress', function (e) {
            e.preventDefault();

            const $recommendedWidthNarrow = $('.recommended-width .narrow');
            const $recommendedWidthRegular = $('.recommended-width .regular');
            const selectedOption = $fitGuideCalculator.find('.size-options .selected');
            const selectedLengthLeft = $('#length-select-left option').filter(':selected').val();
            const selectedWidthLeft = $('#width-select-left option').filter(':selected').val();
            const selectedLengthRight = $('#length-select-right option').filter(':selected').val();
            const selectedWidthRight = $('#width-select-right option').filter(':selected').val();
            const allValuesSelected =
                selectedLengthLeft && selectedWidthLeft && selectedLengthRight && selectedWidthRight;
            let selectedOptionVal;
            let sizeChart;

            for (let x = 0; x < Object.keys(sizes).length; x++) {
                const currentSizeChart = Object.keys(sizes)[x];
                if (selectedOption.hasClass(currentSizeChart)) {
                    sizeChart = sizes[currentSizeChart];
                    selectedOptionVal = currentSizeChart;
                    for (let i = 0; i < Object.keys(sizes[currentSizeChart]).length; i++) {
                        const currentSizeChartGender = Object.keys(sizes[currentSizeChart])[i];
                        if (selectedOption.hasClass(currentSizeChartGender)) {
                            sizeChart = sizes[currentSizeChart][currentSizeChartGender];
                        }
                    }
                }
            }

            showErrorsSelect();

            const leftFootResult = getSuggestedSize(selectedLengthLeft, selectedWidthLeft, sizeChart);
            const rightFootResult = getSuggestedSize(selectedLengthRight, selectedWidthRight, sizeChart);
            let result;

            if (leftFootResult && rightFootResult) {
                if (leftFootResult.eu != rightFootResult.eu) {
                    result = leftFootResult.eu > rightFootResult.eu ? leftFootResult : rightFootResult;
                } else {
                    result = leftFootResult;
                    if (leftFootResult.regular || rightFootResult.regular) {
                        result = leftFootResult.regular ? leftFootResult : rightFootResult;
                    }
                }
            } else if (leftFootResult || rightFootResult) {
                result = leftFootResult ? leftFootResult : rightFootResult;
            }

            const $finalResult = $fitGuideCalculator.find('.result');
            const footInfoLeft = $fitGuideCalculator.find('.selected-left-foot-info');
            const footInfoRight = $fitGuideCalculator.find('.selected-right-foot-info');
            let width = '';

            if ($.isEmptyObject(result) || !allValuesSelected) {
                if (!inputFieldError) {
                    showError();
                }
                return;
            }

            showProductEventSend = false;

            const mainSizingLocale = $('.fit-guide').data('main-region');
            const alternativeSizingLocale = $('.fit-guide').data('alternative-region');

            const resultSize = `${result[mainSizingLocale.toLowerCase()]} ${mainSizingLocale.toUpperCase()}`;
            const resultAlternativeSize = result[alternativeSizingLocale.toLowerCase()]
                ? `<span class='separator'>|</span> ${result[alternativeSizingLocale.toLowerCase()]
                      .toString()
                      .toUpperCase()} ${alternativeSizingLocale.toUpperCase()}`
                : '';

            $finalResult.html(resultSize + resultAlternativeSize);

            footInfoLeft.find('.lengthValueLeft').html(selectedLengthLeft + ' mm');
            footInfoLeft.find('.widthValueLeft').html(selectedWidthLeft + ' mm');
            footInfoRight.find('.lengthValueRight').html(selectedLengthRight + ' mm');
            footInfoRight.find('.widthValueRight').html(selectedWidthRight + ' mm');

            if (result.narrow === true) {
                $recommendedWidthRegular.hide();
                $recommendedWidthNarrow.css('display', 'flex');
                width = 'narrow';
            } else if (result.regular === true) {
                $recommendedWidthNarrow.hide();
                $recommendedWidthRegular.css('display', 'flex');
                width = 'regular';
            }

            if (window.dataLayer) {
                let calculateEvent = isCart ? 'fitGuide_sizeCalculated_Cart' : 'fitGuide_sizeCalculated';

                window.dataLayer.push({
                    event: calculateEvent,
                    sizeCalculaterOutput: result.eu + '_' + width + '_' + selectedOptionVal
                });
            }

            let translatedWidth = $('input[name="translatedWidth"]');

            if (translatedWidth && translatedWidth.length) {
                let parsed = JSON.parse(translatedWidth.val());
                if (parsed && Object.keys(parsed).length) {
                    width = parsed[width];
                }
            }

            //set size filter depending on the alternative size in the Fit Guide JSON object
            const mainSizeFilter = result[[`${mainSizingLocale.toLowerCase()}`]];
            const alternativeSizeFilter = result[alternativeSizingLocale.toLowerCase()] || '';

            //set variables which are holding the sizeFilter by priority depending on each locale.
            let useAsMainFilter = mainSizeFilter;
            let useAsAlternativeFilter;

            useAsAlternativeFilter = alternativeSizeFilter;

            if ($('.fit-guide').data('use-alternative-as-main')) {
                useAsMainFilter = alternativeSizeFilter;
                useAsAlternativeFilter = mainSizeFilter;
            }
            const sizeFilter = ('|' + useAsMainFilter + ';' + useAsAlternativeFilter + '|').replace(',', '.');

            let url = urlUtil.appendParamsToUrl(categoryUrl, {
                prefn1: 'sizeName',
                prefv1: sizeFilter,
                prefn2: 'width',
                prefv2: width
            });

            // Render Product Suggestion
            if (isPDP) {
                $.ajax({
                    url: Urls.productSuggestion,
                    type: 'GET',
                    data: {
                        pid: pid,
                        calculationResult: JSON.stringify(result),
                        mainsizing: mainSizingLocale,
                        alternativesizing: alternativeSizingLocale
                    },
                    dataType: 'html',
                    success: function (response) {
                        $fitGuideResult.find('.product-suggestion').html(response);

                        if ($('.missing-product-suggestion').length > 0) {
                            $notFoundSuggestionMessage.removeClass('unvisible');
                            $exploreButton.removeClass('unvisible');
                        } else {
                            $notFoundSuggestionMessage.addClass('unvisible');
                            $exploreButton.addClass('unvisible');
                        }

                        $fitGuideResult.find('.fylin-link-avaliability').on('click', function () {
                            offcanvasdialog.closeAll();
                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    event: 'fitGuideAvailabilityReminder'
                                });
                            }
                        });

                        $fitGuideResult.find('.add-to-cart').on('click', function (e) {
                            e.preventDefault();
                            const $this = $(this);
                            const $form = $this.closest('form');
                            const membersOnlyFlyin = require('../flyins/membersonlyflyin');

                            if (
                                $this.hasClass('member-shop') ||
                                $this.hasClass('pre-order-button') ||
                                $this.hasClass('member-exclusives') ||
                                $this.hasClass('sign-in-to-buy')
                            ) {
                                offcanvasdialog.closeAll();

                                // Wait for the Fit Guide fly-in to fully close before opening the Registering fly-in.
                                $('.ocd-flyin').on('hidden', function () {
                                    $(this).off('hidden');
                                    membersOnlyFlyin.init(e.target);
                                });
                            } else {
                                addToCart.addItemToCart($form).then(function (response) {
                                    offcanvasdialog.closeAll();

                                    // Wait for the Fit Guide fly-in to fully close before opening the Shopping Cart fly-in.
                                    $('.ocd-flyin').on('hidden', function () {
                                        $(this).off('hidden');
                                        updateMiniCart(response, true);
                                    });
                                });
                            }
                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    event: 'fitGuideAddToCart'
                                });
                            }
                        });
                    }
                });
            }

            if (isCart) {
                $backToCart.removeClass('unvisible');
                $backToCart.on('click', function () {
                    offcanvasdialog.closeAll();
                    $('html, body').animate({
                        scrollTop: 0
                    });
                });
            }

            showResult();

            $('.container-result .button-wrapper button.button-link').on('click', function () {
                var $button = $(this);
                if (!$button.hasClass('back-to-cart')) {
                    if (window.dataLayer && !showProductEventSend && $button.hasClass('show-products')) {
                        window.dataLayer.push({
                            event: 'fitGuideShowProducts'
                        });
                        showProductEventSend = true;
                    } else if (!$button.hasClass('show-products')) {
                        url = urlUtil.appendParamToURL(Urls.homeShow, 'home-show', true);
                    }
                    window.location.href = $button.data('url') || url;
                }
            });

            function showResult() {
                $fitGuideForm.removeClass('active');
                $fitGuideResult.addClass('active');
                $fitGuideForm.removeClass('invalid-measurements');
                scrollToResult();
            }

            function showError() {
                scrollToResult();
                $fitGuideForm.addClass('invalid-measurements');
            }

            /**
             * Scrolls to the top of the Fit Guide container.
             *
             * @returns {void}
             */

            function scrollToResult() {
                if (isPDP || isCart) {
                    if ($('.warning-form-not-found-suggestion').hasClass('unvisible')) {
                        $fitGuideCalculator.find('.scrolling-content').animate({
                            scrollTop: 0
                        });
                    } else {
                        var element = document.getElementsByClassName('missing-product-suggestion')[0];
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }
                    }
                } else if (util.isMobileOrTablet()) {
                    $('html, body').animate({
                        scrollTop: $fitGuideCalculator.offset().top - $('.header-wrapper.hide-on-desktop').outerHeight()
                    });
                } else {
                    $('html, body').animate({
                        scrollTop: $fitGuideCalculator.offset().top - $('.header-wrapper.only-on-desktop').outerHeight()
                    });
                }
            }
            /**
             * Adds error messages to the measurement fields.
             *
             * @returns {void}
             */
            function showErrorsSelect() {
                clearSelect();
                $measurementFields.each(function () {
                    const selectedValue = $(this).find('option').filter(':selected').val();
                    const $formRow = $(this).closest('.form-row');

                    if (!selectedValue) {
                        $formRow.addClass('validation-error');
                        $fitGuideForm.addClass('error');
                        inputFieldError = true;
                    }
                });
            }

            function getSuggestedSize(length, width, sizeChart) {
                if ($.isEmptyObject(sizes)) {
                    return '';
                }

                const setSizeChart =
                    sizeChart.men && sizeChart.women ? sizeChart.men.concat(sizeChart.women) : sizeChart;

                return setSizeChart
                    .filter(function (size) {
                        return (
                            (inRange(length, size.lengthNarrow) && inRange(width, size.widthNarrow)) ||
                            (inRange(length, size.lengthRegular) && inRange(width, size.widthRegular))
                        );
                    })
                    .map(function (size) {
                        return {
                            eu: size.sizeEU,
                            uk: size.sizeUK,
                            us: size.sizeUS,
                            jp: size.sizeJP,
                            narrow: inRange(width, size.widthNarrow) && inRange(length, size.lengthNarrow),
                            regular: inRange(width, size.widthRegular) && inRange(length, size.lengthRegular)
                        };
                    })
                    .reduce(
                        (suggestedSize, size) => (suggestedSize = suggestedSize > size.sizeEU ? suggestedSize : size),
                        null
                    );
                function inRange(value, values) {
                    return value >= values[0] && value <= values[1];
                }
            }
        });
        /**
         * Removes all error messages from the measurement fields.
         *
         * @returns {void}
         */
        function clearSelect() {
            $measurementFields.removeClass('validation-error');
            $fitGuideForm.removeClass('error');
            inputFieldError = false;
        }
        function restartCalculator() {
            $fitGuideForm.addClass('active');
            $fitGuideResult.removeClass('active');
            $fitGuideForm.removeClass('invalid-measurements');
            $fitGuideResult.find('.product-suggestion').empty();
        }
        const $sizeOption = $fitGuideCalculator.find('.size-options .option');
        const $backButton = $('.fit-guide').find('.back-button');
        const $ocdOverlay = $('.ocd-overlay');
        const $ocdClose = $('.ocd-close');

        $sizeOption.on('click keypress', setDefaultOption);
        $backButton.on('click keypress', setDefaultOption);
        $ocdOverlay.on('click keypress', setDefaultOption);
        $ocdClose.on('click keypress', setDefaultOption);

        function setDefaultOption(e) {
            const $fitGuideEvent = $(this);
            $fitGuideEvent.siblings().removeClass('selected');
            $fitGuideEvent.addClass('selected');
            const $lengthDropdowns = $fitGuideForm.find('select[id^="length"]');
            const $widthDropdowns = $fitGuideForm.find('select[id^="width"]');
            const defaultLengthOption = $('#length-select-left option:disabled');
            const defaultWidthOption = $('#width-select-left option:disabled');

            $lengthDropdowns.find('option:not(:first)').remove();
            $widthDropdowns.find('option:not(:first)').remove();
            $('*[id^="uniform-length-select"]').find('span').text(defaultLengthOption.text());
            $('*[id^="uniform-width-select"]').find('span').text(defaultWidthOption.text());
            $('.fit-guide-form .selector select').val('');
            fitguideselectedmillimeters.init(sizes);
            $fitGuideCalculator.find('.select-wrapper select').closest('.form-row').removeClass('chosen-size');
        }

        /**
         * Updates the products shown in the mini cart.
         *
         * @param response
         * @param showOverlay
         * @returns {void}
         */
        function updateMiniCart(response, showOverlay) {
            var splitted = response.split(util.contentSplitter);
            var options = {};

            if (splitted && splitted.length) {
                try {
                    options = JSON.parse(splitted[1]);
                } catch (err) {
                    // nothing to do, default value is {}
                }

                if (showOverlay && splitted[2]) {
                    cartoverlay.show(splitted[2]);
                }

                if (splitted[0]) {
                    minicart.update(splitted[0], options);
                }
            }
        }

        /**
         * Track fit guide flyin opening. We need to fire the event only once.
         *
         * @returns {void}
         */
        $('.flyin-product-info-fit-guide').one('click keypress', e => {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: isCart ? 'fitGuide_flyIn_Cart' : 'fitGuide_flyIn',
                    ecomm_prodid: pid
                });
            }
        });
    }
};

module.exports = fitGuideOnClickEvents;
